export default __webpack_public_path__ + "static/photo-27-2f47d6cdc59f1b755cef7bdf787cbfa1.jpg";